import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth-service';

@Component({
    selector: 'app-manage-menu',
    templateUrl: './managemenu.component.html'
})
export class ManageMenuComponent implements OnInit {
    constructor(private _authService: AuthService) { }
    logout() {
        this._authService.logout();
    }
    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/managemenu/managemenu.component.ts